export default {
  title: 'Easy Air Screen',
  subtitle: 'Transforme seu tablet em um segundo monitor sem fio',
  description: 'Transforme seu tablet em uma tela sem fio de alta qualidade para macOS. Expanda seu espaço de trabalho e aumente a produtividade—sem cabos necessários.',
  downloadMobile: 'Baixar Aplicativo Móvel',
  purchasePromise: 'Compra única. Sem assinatura e sem anúncios.',
  companionPromise: 'O aplicativo para Mac é gratuito e não exige uma conta.',
  downloadMacOS: 'Baixar para macOS (Universal)',
  quickSetup: 'Configuração Rápida',
  setupSteps: [
    'Instale o Easy Air Screen no seu tablet',
    'Baixe e instale o aplicativo desktop para macOS',
    'Conecte ambos os dispositivos à mesma rede Wi-Fi',
    'Inicie e conecte!'
  ],
  performanceTip: 'Dica de Desempenho',
  performanceDescription: 'Para a melhor experiência com atraso mínimo, use uma conexão Wi-Fi de 5GHz em ambos os dispositivos. Se notar latência, tente diminuir a resolução nas configurações do aplicativo.',
  faqTitle: 'Perguntas frequentes',
  faq: [
    {
      q: 'Qual é a diferença em relação ao Sidecar?',
      a: 'Easy Air Screen funciona mesmo quando os dois dispositivos usam Apple ID diferentes. Você também pode usar um tablet Android como monitor secundário sem fio para o seu Mac.'
    },
    {
      q: 'Posso usar com um tablet Android?',
      a: 'Sim. Você pode usar um tablet Android como monitor secundário sem fio para o seu Mac. Conecte os dois dispositivos à mesma rede Wi-Fi para estender ou espelhar a tela.'
    },
    {
      q: 'Um iPhone pode virar uma tela secundária?',
      a: 'Sim. Um iPhone pode ser usado como monitor secundário sem fio para o seu Mac. Ao conectar, escolha entre estender a área de trabalho ou espelhar a tela.'
    },
    {
      q: 'Ele estende a tela ou faz espelhamento?',
      a: 'Ele oferece as duas opções. Você pode estender a área de trabalho do Mac para outra tela ou espelhar a tela atual para exibir o mesmo conteúdo.'
    },
    {
      q: 'Preciso de internet? Minha tela sai da rede?',
      a: 'Não é necessário ter conexão com a internet. Os dispositivos se conectam diretamente na mesma rede Wi-Fi, sem enviar ou armazenar a tela em um servidor externo.'
    },
    {
      q: 'É uma assinatura?',
      a: 'Não. O app do dispositivo é comprado uma única vez, não é assinatura e não tem anúncios. O app complementar para Mac é gratuito e não exige conta.'
    },
    {
      q: 'Funciona em PC com Windows?',
      a: 'Não. Easy Air Screen é feito exclusivamente para macOS. Windows PC não é compatível no momento.'
    },
    {
      q: 'O que fazer se a tela estiver lenta ou travando?',
      a: 'Conecte os dois dispositivos a uma rede Wi-Fi de 5GHz, se possível. Se ainda houver atraso, diminua a resolução nas configurações do app.'
    },
  ]
};
